// @ts-nocheck

/**
 * * `idle` - idle
 * `pending` - pending
 * `generating` - generating
 * `ready` - ready
 * `failed` - failed
 */
export type PremadeCoverPreviewResponseStatusEnum =
  typeof PremadeCoverPreviewResponseStatusEnum[keyof typeof PremadeCoverPreviewResponseStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PremadeCoverPreviewResponseStatusEnum = {
  idle: "idle",
  pending: "pending",
  generating: "generating",
  ready: "ready",
  failed: "failed",
} as const;
